// The staff shape is identical in both queries, so the selection is shared rather than
// typed out twice and drifting.
const STAFF_FIELDS = `
      _id
      first_name
      last_name
      email
      is_active
      is_moksha_staff
      active_property_count
      granted_by
      granted_at
      properties {
        name
        link_active
        hotel_active
      }`;

export const LIST_MOKSHA_STAFF = `query ($pageNumber: Int, $pageSize: Int) {
  list_moksha_staff(page_number: $pageNumber, page_size: $pageSize) {
    message
    total
    unrecorded
    hasMore
    data {${STAFF_FIELDS}
    }
  }
}`;

export const SEARCH_HOTEL_STAFF = `query ($email: String!) {
  search_hotel_staff(email: $email) {
    message
    result
    data {${STAFF_FIELDS}
    }
  }
}`;

export const SET_MOKSHA_STAFF = `mutation ($staffId: String!, $isMokshaStaff: Boolean!) {
  set_moksha_staff(staff_id: $staffId, is_moksha_staff: $isMokshaStaff) {
    message
  }
}`;
